/**
 * Billing is half upstream. ows-mail answers identity, status and the SLOT (`role` and `billing`:
 * free / paid) on `GET /accounts`, and nothing about `invoiceId`: it has no provider counterpart, and
 * no service of ours owns it yet. So the live source MERGES: identity, status and slot from the
 * service, the invoice from the section's local layer (the per-brand record in `store.ts`), matched
 * on `email`.
 */
import type { MailboxRecord } from '../../../mock-data/mailbox-records';
import type { MailboxAccount } from './client';

/**
 * The section's rows: each account from the service, slot and all, with the invoice the local layer
 * holds for that address. The local layer never decides the slot. An address it does not know (the
 * normal case on a fresh domain, not an edge case) has no invoice.
 */
export const mergeBilling = (
  accounts: readonly MailboxAccount[],
  local: readonly MailboxRecord[] | null,
): MailboxRecord[] => {
  const known = new Map((local ?? []).map((row) => [row.email, row]));
  // TODO(billing): the invoice belongs to a service that does not exist yet. The slot already comes
  // from ows-mail.
  return accounts.map((account) => {
    const invoiceId = known.get(account.email)?.invoiceId;
    return invoiceId ? { ...account, invoiceId } : { ...account };
  });
};
